import React from "react"
import { Box } from "@mui/material"
import ProgressBar from 'src/v2/pages/MotorCadastros/components/ProgressBar/progress-bar'
import {renderCellDateTime} from "src/utils/table-render-functions"

export const cadastroLoteColumnsTable = () => [
    {
        field: "modelo",
        headerName: "Modelo",
        flex: 1,
        minWidth: 180,
    },
    {
        field: "status",
        headerName: "Status",
        flex: 1,
        minWidth: 120,
    },
    {
        field: "totalRegistros",
        headerName: "Total Registros",
        flex: 1,
        minWidth: 140,
    },
    {
        field: "progresso",
        headerName: "Progresso",
        flex: 1,
        minWidth: 180,
        sortable: false,
        renderCell: (params) => (
            <Box
                sx={{
                    width: "100%",
                    py: 1.5,
                    pr: 2,
                }}
            >
                <ProgressBar value={params.value || 0} />
            </Box>
        ),
    },
    {
        field: "logErro",
        headerName: "Log Erro",
        flex: 1,
        minWidth: 140,
    },
    {
        field: "usuario",
        headerName: "Usuário",
        flex: 1,
        minWidth: 140,
    },
    {
        field: "dataCriacao",
        headerName: "Data Criação",
        flex: 1,
        minWidth: 200,
        renderCell: (params) => renderCellDateTime(params)
    },
    {
        field: "dataAtualizacao",
        headerName: "Data Atualização",
        flex: 1,
        minWidth: 200,
        renderCell: (params) => renderCellDateTime(params)
    },
]

export default cadastroLoteColumnsTable